<template>
  <div class="container" style="padding: 30px; margin-top: 50px">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card shadow-sm">
          <div class="card-body">
            <h3 class="text-center mb-4">เข้าสู่ระบบ</h3>

            <div class="mb-4">
              <label class="form-label d-block">กรุณาเลือกประเภทผู้ใช้งาน</label>

              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  id="role-admin"
                  value="admin"
                  v-model="selectedRole"
                  @change="resetParticipantForm"
                />
                <label class="form-check-label" for="role-admin">
                  ผู้ดำเนินโครงการ
                </label>
              </div>

              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  id="role-participant"
                  value="participant"
                  v-model="selectedRole"
                  @change="resetParticipantForm"
                />
                <label class="form-check-label" for="role-participant">
                  ผู้เข้าร่วมโครงการ
                </label>
              </div>
            </div>

            <div v-if="selectedRole === 'admin'" class="text-center">
              <button class="btn btn-primary btn-lg" @click="goToLogin">
                ไปหน้าเข้าสู่ระบบ
              </button>
            </div>

            <div
              v-if="selectedRole === 'participant'"
              class="container"
              style="padding: 30px; margin-top: 20px"
            >
              <div class="col-md-12 mb-3 mt-3" style="margin: 15px">
                <div class="full-center">
                  <div class="card generator-card">
                    <div class="card-body">
                      <div class="form-vertical">
                        <div class="form-row mb-3">
                          <label class="form-label">หมายเลขสุ่ม:</label>
                          <input
                            v-model.number="data.random_number"
                            type="number"
                            min="1"
                            class="form-control generator-input"
                            placeholder="เช่น 1234"
                            :disabled="randomChecked"
                          />
                        </div>

                        <div class="d-flex gap-2 mb-3">
                          <button
                            type="button"
                            class="btn btn-primary"
                            @click="checkRandomNumber"
                            :disabled="checkingRandom || randomChecked"
                          >
                            {{ checkingRandom ? "กำลังตรวจสอบ..." : "ตรวจสอบหมายเลขสุ่ม" }}
                          </button>

                          <button
                            v-if="randomChecked"
                            type="button"
                            class="btn btn-outline-secondary"
                            @click="editRandomNumber"
                          >
                            เปลี่ยนหมายเลขสุ่ม
                          </button>
                        </div>

                        <div v-if="randomChecked">
                          <div class="form-row mb-3">
                            <label class="form-label">ชื่อ:</label>
                            <input
                              v-model="data.firstname"
                              type="text"
                              class="form-control generator-input"
                            />
                          </div>

                          <div class="form-row mb-3">
                            <label class="form-label">นามสกุล:</label>
                            <input
                              v-model="data.lastname"
                              type="text"
                              class="form-control generator-input"
                            />
                          </div>

                          <div class="form-row mb-3">
                            <label class="form-label">เบอร์โทรศัพท์:</label>
                            <input
                              v-model="data.phone"
                              type="number"
                              class="form-control generator-input"
                              placeholder="กรอกเบอร์โทรศัพท์"
                            />
                          </div>

                          <div class="text-end mt-3">
                            <button
                              type="button"
                              class="btn btn-success btn-lg generator-btn"
                              @click="register"
                            >
                              คลิก
                            </button>
                          </div>
                        </div>

                        <div v-if="selectedRole === 'participant' && !randomChecked" class="text-muted mt-2">
                          กรุณาตรวจสอบหมายเลขสุ่มก่อน
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="!selectedRole" class="text-muted text-center mt-3">
              กรุณาเลือกประเภทผู้ใช้งาน
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MonitoringNumberService from "../services/MonitoringNumberService";
import ParticipantService from "../services/ParticipantService";

export default {
  name: "SelectUserType",
  data() {
    return {
      selectedRole: "",
      checkingRandom: false,
      randomChecked: false,
      monitoringData: null,
      data: {
        random_number: null,
        monitoring_number_id: null,
        firstname: "",
        lastname: "",
        phone: ""
      }
    };
  },
  methods: {
    goToLogin() {
      this.$router.push({ name: "login" });
    },

    resetParticipantForm() {
      this.checkingRandom = false;
      this.randomChecked = false;
      this.monitoringData = null;
      this.data = {
        random_number: null,
        monitoring_number_id: null,
        firstname: "",
        lastname: "",
        phone: ""
      };
    },

    editRandomNumber() {
      this.randomChecked = false;
      this.monitoringData = null;
      this.data.monitoring_number_id = null;
      this.data.firstname = "";
      this.data.lastname = "";
      this.data.phone = "";
    },

    async checkRandomNumber() {
      if (this.data.random_number === "" || this.data.random_number === null) {
        alert("กรุณากรอกหมายเลขสุ่ม");
        return;
      }

      this.checkingRandom = true;

      try {
        const response = await MonitoringNumberService.get_monitoring_number(this.data.random_number);

        if (response.status !== 200 || !response.data) {
          alert("ไม่พบหมายเลขสุ่มนี้ในระบบ กรุณาตรวจสอบหมายเลขสุ่มอีกครั้ง");
          return;
        }

        if (Array.isArray(response.data) && response.data.length === 0) {
          alert("ไม่พบหมายเลขสุ่มนี้ในระบบ กรุณาตรวจสอบหมายเลขสุ่มอีกครั้ง");
          return;
        }

        this.monitoringData = response.data;
        console.log(this.monitoringData,"monitoringData");
        
        this.data.monitoring_number_id = response.data.id;
        this.randomChecked = true;
      } catch (error) {
        console.log(error);
        alert("ไม่พบหมายเลขสุ่มนี้ในระบบ กรุณาตรวจสอบหมายเลขสุ่มอีกครั้ง");
      } finally {
        this.checkingRandom = false;
      }
    },

    getDeviceId() {
      let deviceId = localStorage.getItem("device_id");
      if (!deviceId) {
        deviceId = "web-" + Math.random().toString(36).substring(2) + Date.now();
        localStorage.setItem("device_id", deviceId);
      }
      return deviceId;
    },

    async register() {
      if (!this.randomChecked || !this.data.monitoring_number_id) {
        alert("กรุณาตรวจสอบหมายเลขสุ่มก่อน");
        return;
      }

      if (this.data.firstname === "" || this.data.firstname == null) {
        alert("กรุณากรอกชื่อ");
        return;
      }

      if (this.data.lastname === "" || this.data.lastname == null) {
        alert("กรุณากรอกนามสกุล");
        return;
      }

      if (this.data.phone === "" || this.data.phone == null) {
        alert("กรุณากรอกเบอร์โทรศัพท์");
        return;
      }

      try {
        if (this.monitoringData.active == true) {
          const response = await ParticipantService.get_participant_by_monitoring(
            this.data.monitoring_number_id
          );
console.log(response,"response");

          if (
            response.data.firstname == this.data.firstname &&
            response.data.lastname == this.data.lastname
          ) {
            // localStorage.removeItem("usernilin");
            // console.log(response.data,'response.data');
            // localStorage.setItem('usernilin',JSON.stringify(response.data));
            this.$router.push({
              name: "home",
              params: {
                id: response.data.imei,
                participant_id: response.data.id
              }
            }).catch(err => {
              console.log(err);
            });

            return;
          } else {
            alert("หมายเลขสุ่มนี้ถูกใช้งานแล้ว กรุณาตรวจสอบหมายเลข ชื่อ หรือนามสกุลอีกครั้ง");
            return;
          }
        }else{
          this.data.device_id = this.getDeviceId();

        const registered = {
          monitoring_number_id: this.data.monitoring_number_id,
          imei: this.data.device_id,
          firstname: this.data.firstname,
          lastname: this.data.lastname,
          phone: this.data.phone
        };

        const createResponse = await ParticipantService.create_participants(registered);

        if (createResponse.status !== 200) {
          alert(createResponse.data.message || "เกิดข้อผิดพลาด");
          return;
        }

        const update = {
          active: true,
          updated_by: createResponse.data.id
        };

        await MonitoringNumberService.updatemonitoring_number(
          this.data.monitoring_number_id,
          update
        );

        // localStorage.removeItem("usernilin");
        // console.log(createResponse.data,'createResponse.data');
        // localStorage.setItem('usernilin',JSON.stringify(createResponse.data));

        this.$router.push({
          name: "home",
          params: {
            id: createResponse.data.imei,
            participant_id: createResponse.data.id
          }
        }).catch(err => {
          console.log(err);
        });
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
.full-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.generator-card {
  width: 100%;
  max-width: 700px;
  border-radius: 12px;
}

.generator-input {
  height: 45px;
}

.generator-btn {
  min-width: 120px;
}

.form-label {
  font-weight: 600;
  margin-bottom: 6px;
}

.form-row {
  margin-bottom: 12px;
}

.gap-2 {
  gap: 8px;
}
</style>